var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "recepcionEquipos",
      attrs: { fluid: "", "grid-list-md": "" }
    },
    [
      _c("v-tabs", [_c("v-tab", [_vm._v("Recepción de Equipos")])], 1),
      _c("v-divider"),
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm3: "", md3: "" } },
                [
                  _c("DatePicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.dateStart.label,
                      "data-vv-name": "fechaInicioRequerida",
                      "error-messages": _vm.errors.collect(
                        "fechaInicioRequerida"
                      ),
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.dateStart.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.dateStart, "value", $$v)
                      },
                      expression: "formFields.dateStart.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm3: "", md3: "" } },
                [
                  _c("DatePicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.dateEnd.label,
                      "data-vv-name": "fechaFinRequerida",
                      "error-messages": _vm.errors.collect("fechaFinRequerida"),
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.dateEnd.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.dateEnd, "value", $$v)
                      },
                      expression: "formFields.dateEnd.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs5: "",
                    sm5: "",
                    md5: "",
                    layout: "",
                    "mt-0": "",
                    "ml-4": ""
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-sm-center botones-filtros mt-1" },
                    [
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function($event) {
                              return _vm.filtrar()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "#27488e" } }, [
                            _vm._v("search")
                          ]),
                          _vm._v("Filtrar\n          ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function($event) {
                              return _vm.clearFilters()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "#27488e" } }, [
                            _vm._v("clear")
                          ]),
                          _vm._v("Limpiar")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", small: "", color: "primary" },
                          on: { click: _vm.getCSV }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _vm._v("\n              \n            "),
                          _c("span", { staticClass: "importExportBtnTexto" }, [
                            _vm._v("Exportar"),
                            _c("br"),
                            _vm._v("CSV")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.estado.label,
                      items: _vm.estados,
                      "item-text": "configvalor",
                      "item-value": "configid",
                      clearable: ""
                    },
                    model: {
                      value: _vm.formFields.estado.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.estado, "value", $$v)
                      },
                      expression: "formFields.estado.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs4: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Buscar", clearable: "", outlined: "" },
                on: {
                  keyup: function($event) {
                    return _vm.gridApi.setQuickFilter(_vm.filtro)
                  },
                  "click:clear": function($event) {
                    return _vm.gridApi.setQuickFilter("")
                  }
                },
                model: {
                  value: _vm.filtro,
                  callback: function($$v) {
                    _vm.filtro = $$v
                  },
                  expression: "filtro"
                }
              })
            ],
            1
          ),
          _c("v-flex", {
            attrs: { xs12: "", sm6: "", md6: _vm.accionCrear.visible }
          }),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md2: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _vm.accionCrear.visible
                    ? _c(
                        "v-btn",
                        {
                          staticStyle: { "padding-right": "20px" },
                          attrs: { color: "#ffe800" },
                          on: {
                            click: function($event) {
                              _vm.showModalNew = true
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { color: "black" },
                              attrs: { dark: "", left: "" }
                            },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c("span", { staticStyle: { color: "black" } }, [
                            _vm._v("Crear")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card proveedores" },
        [
          _c("MantenedorGridSinCodigo", {
            staticClass: "ag-theme-material",
            attrs: {
              gridOptions: _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.showModal
        ? _c("Movimiento", {
            attrs: {
              esEdicion: _vm.modalEsEdicion,
              edited: _vm.editedItem,
              usuarioActivo: _vm.usuarioActivo,
              estados: _vm.estados,
              recibido: _vm.recibido
            },
            on: {
              modalAsociacionEmit: function($event) {
                return _vm.moduloModalCallback($event)
              },
              actualizar: function($event) {
                return _vm.getFiltrados()
              }
            }
          })
        : _vm._e(),
      _vm.showPopUpReport
        ? _c("PopUpGeneratedReports", {
            attrs: { text: _vm.msgReport },
            on: { cerrar: _vm.handleCloseReport }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }